import * as $ from 'jquery';
import { disposableSubscription, serialDisposable } from 'common/barrels/core';
import { Observable } from 'common/barrels/rx';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';

export class TimerControl extends LooklessControl {
    private interval: number;
    private autoReset: boolean;
    private timer = serialDisposable(null);

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.interval = this.config['content.Interval'];
        this.autoReset = this.config['content.AutoReset'];

        this.subscriptions = this.processBindings(this.config);
    }

    dispose() {
        super.dispose();
        this.timer.dispose();
    }

    startTimer() {
        this.timer.set(disposableSubscription(Observable.interval(this.interval * 1000).let(x => this.autoReset ? x : x.first()).subscribe(() => this.triggerEvent('TimerElapsed'))));
    }

    stopTimer() {
        this.timer.set(null);
    }

    'content.Interval'(value: number) {
        this.interval = value;
    }

    'content.AutoReset'(value: boolean) {
        this.autoReset = value;
    }
}

registerBinding('timercontrol', TimerControl);
